/**
 * External Imports
 */
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import { completeTask } from '../../../../redux/actions';

/**
 * Style Imports
 */
import { StyledMarkCompleteBtn } from './MarkCompleteBtn.styles';

interface ICompleteProps {
  edit?: boolean;
  taskId?: string;
  taskType: string;
}

const MarkCompleteBtn: FC<ICompleteProps> = ({ edit, taskId, taskType }) => {
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  return (
    <StyledMarkCompleteBtn
      id="Mark-Complete-Button"
      className="d-flex neu-text-green-60"
      kind="secondary"
      icon="check"
      size="small"
      onClick={e => {
        e.stopPropagation();
        if (taskId)
          dispatch(
            completeTask({
              deepLink: pathname.includes('task/complete'),
              taskId,
              edit,
              taskType
            })
          );
      }}
    >
      Mark Complete
    </StyledMarkCompleteBtn>
  );
};

const mapReduxStateToProps = (state: RootState) => ({
  taskData: state.ModalReducer.modalData
});

export default connect(mapReduxStateToProps)(MarkCompleteBtn);
